import React from "react"
import {HashRouter as Router, Route, Routes} from "react-router-dom"
import AllHeader from "./components/AllHeader"
import HomePageCards from "./components/Cards/HomePageCards"
import Footer from "./components/footer"
import ShowAllMenu from "./components/ShowAllMenu/ShowAllMenu"
import Popup from "./components/Popup/PopUp"

function App() {
  if (process.env.NODE_ENV === "development") {
    console.error = () => {}
    console.warn = () => {}
    console.log = () => {}
  }

  return (
    <Router>
      <div className="App" style={{margin: "0px", padding: "0px"}}>
        <AllHeader />
        <Popup />
        <Routes>
          <Route path="/" element={<HomePageCards />} />
          <Route path="/show-all-menu" element={<ShowAllMenu />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  )
}

export default App
